module.exports = __webpack_public_path__ + "static/media/gallery-new-4.5ece69cb.jpg";